var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"schedule-appointment"},[_vm._t("side-bar"),_c('div',{staticClass:"schedule-appointment__wrap"},[_c('div',{staticClass:"only-print"},[_vm._t("only-print")],2),_vm._t("default")],2),_c('side-slide-transition',[_vm._t("side-dialogs")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }